import React, { type ReactElement } from 'react'
import verificationBackground from 'assets/verificationBackground.svg'
import { Typography } from '@mui/material'

import styles from './UserNotAuthorized.module.scss'

const UserNotAuthorized: React.FC = (): ReactElement => {
  return (
    <div
      className={styles.infoWrapper}
      style={{
        backgroundImage: `url(${verificationBackground})`,
      }}
    >
      <div className={styles.content}>
        <Typography variant="title1" className={styles.text}>
          Morate biti pravno lice da bi mogli da koristite ovu aplikaciju.
        </Typography>
      </div>
    </div>
  )
}

export default UserNotAuthorized
